@if (active) {
    <div class="tab-pane">
        <ng-content></ng-content>
    </div>
}
